import { useRef, useState, useEffect } from "react";
import cn from "classnames";

import SmallLoader from "components/SmallLoader/SmallLoader";

import styles from "./secondary.module.scss";

interface SecondaryButtonInterface {
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  icon?: string;
  children: string;
  onClick?: () => void;
  isLoading?: boolean;
  isDisable?: boolean;
  className?: string;
}

const SecondaryButton = ({
  type,
  children,
  icon,
  isLoading,
  onClick,
  isDisable,
  className
}: SecondaryButtonInterface) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [children, icon]);

  return (
    <button
      ref={buttonRef}
      type={type ?? "button"}
      className={cn(
        styles["secondary"],
        {
          [styles["secondary--disable"]]: isDisable
        },
        className
      )}
      onClick={onClick}
      disabled={isDisable}
      style={{ minWidth: buttonWidth }}
    >
      {isLoading ? (
        <SmallLoader type="ORANGE" />
      ) : (
        <>
          {icon && <img src={icon} alt={`${children} button icon`} />}
          {children}
        </>
      )}
    </button>
  );
};

export default SecondaryButton;
